
/////////////////////////////
/// MULTIPLE CHOICE QUIZ ///

var _multipleChoiceVideoPlayers = [];
function initMultipleChoice() {

	if ($(".multipleChoice").length > 0) {

		//init youtube script
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		$("body").prepend(tag);

		var quizPos = 0;
		$(".multipleChoice").each(function () {
			
			$(this).find(".multipleChoice__answer").prop('checked', false);
			$(this).find(".multipleChoice__answer").removeClass("multipleChoice__answer--selected");

			//save quiz pos in data attr
			$(this).attr("data-quiz-pos", quizPos);
			quizPos++;

			//hide all answers in video-quiz
			if($(this).find(".multipleChoice__video").length > 0){
				$(this).find(".multipleChoice__answers").hide();
				$(this).find(".multipleChoice__question").hide();
			}
			else{
				//show only first question
				showMultipleChoiceFirstQuestion($(this));
			}


			//handle button "next" click
			$(this).find(".multipleChoice__button-next").click(function () {
				
				var $q = $(this).closest(".multipleChoice");
				var activeQuestion = $q.find(".multipleChoice__question.active");
				var nextQuestion = activeQuestion.next(".multipleChoice__question");
				if (nextQuestion.length > 0) {
					
					//console.log("show next question..." + nextQuestion.attr("data-question-number"));
					
					$q.find(".multipleChoice__question-number").html(nextQuestion.attr("data-question-number"));			
					
					//hide results and next button
					$q.find(".multipleChoice__button-next").hide();
					$q.find(".multipleChoice__result").hide();
					$q.find(".multipleChoice__results").hide();
					
					//show next question
					activeQuestion.removeClass("active");
					nextQuestion.addClass("active");
					
					//show next answers
					$q.find(".multipleChoice__answers").hide();
					showMultipleChoiceAnswers($q);
				}
				else {
					//console.log("all questions answered...");
				}
			});
			$(this).find(".multipleChoice__button-next").on("keydown", handleKeyDownForClick);

			//handle answer click
			$(this).find(".multipleChoice__answer").change(function () {

				var $q = $(this).closest(".multipleChoice");
				$q.find(".multipleChoice__answer").removeClass("multipleChoice__answer--selected");
				
				if($(this).is(':checked')){
					
					//show result text
					$q.find(".multipleChoice__result").hide();
					var resultId = $(this).attr("data-result-id");
					$q.find("#" + resultId).show();
					$q.find(".multipleChoice__results").show();
					
					$(this).addClass("multipleChoice__answer--selected");
					
					if ($(this).hasClass("multipleChoice__answer--correct")) {
						//correct answer!
						
						//last question?
						var activeQuestionNumber = $q.find(".multipleChoice__question.active").attr("data-question-number");
						var lastQuestionNumber = $q.find(".multipleChoice__question").last().attr("data-question-number");
						//console.log("lastQuestionNumber:" + lastQuestionNumber + " // lastQuestionNumber:" + lastQuestionNumber);
						if(activeQuestionNumber == lastQuestionNumber){
							//show contest!
							$q.find(".multipleChoice__contest").show();
						}
						else{
							//show button
							$q.find(".multipleChoice__button-next").removeClass("multipleChoice__button-next--disabled");
							$q.find(".multipleChoice__button-next").show();
						}
					}
					else{
						//wrong answer!
						$q.find(".multipleChoice__button-next").hide();
						$q.find(".multipleChoice__contest").hide();
					}					
				}
			});
		});
	}
}

function showMultipleChoiceFirstQuestion($quiz){
	var firstQuestion = $quiz.find(".multipleChoice__question").first();
	firstQuestion.addClass("active");
	
	$quiz.find(".multipleChoice__question-info").children("span").first().html(firstQuestion.attr("data-question-number"));
	$quiz.find(".multipleChoice__question-info").children("span").last().html($quiz.find(".multipleChoice__question").length);
	$quiz.find(".multipleChoice__question-info").removeClass("hidden");

	//show first answers
	showMultipleChoiceAnswers($quiz);
}

function showMultipleChoiceAnswers($q){
	var $activeQuestion = $q.find(".multipleChoice__question.active");
	if($activeQuestion.length > 0){
		$activeQuestion.show();
		var answersId = $q.find(".multipleChoice__question.active").attr("data-answers-class");
		$q.find("." + answersId).show();
	}
}

function onMultipleChoicePlayerReady(event) {
	//console.log("PAN onMultipleChoicePlayerReady()");
	//event.target.playVideo();

	var $q = getMultipleChoiceEventPlayer(event.target);

	//handle video-image click
	$q.find(".multipleChoice__play-button").click(function () {
		var $q = $(this).closest(".multipleChoice");
		var videoPlayer = _multipleChoiceVideoPlayers[$q.attr("data-quiz-pos")];
		if (videoPlayer) {
			$(this).siblings(".multipleChoice__video-image").hide();
			$(this).hide();
			videoPlayer.playVideo();
		}
	});
	$q.find(".multipleChoice__play-button").on("keydown", handleKeyDownForClick);
	$q.find(".multipleChoice__loader").hide();
	$q.find(".multipleChoice__play-button").show();

}
function onMultipleChoicePlayerError(event) {
	//console.log("PAN onMultipleChoicePlayerError()");
}

function onMultipleChoicePlayerStateChange(event) {
	
	var $q = getMultipleChoiceEventPlayer(event.target);

	//handle events
	switch (event.data) {
		case YT.PlayerState.PLAYING:
			break;
		case YT.PlayerState.PAUSED:
			break;
		case YT.PlayerState.BUFFERING:
			break;
		case YT.PlayerState.CUED:
			break;
		case YT.PlayerState.ENDED:
			$q.find(".multipleChoice__video-image").show();
			$q.find(".multipleChoice__play-button").show();
			$q.find(".multipleChoice__video-intro").hide();
			$q.find(".multipleChoice__question.active").show();

			showMultipleChoiceFirstQuestion($q)
			break;
		default:
			//console.log("PAN onMultipleChoicePlayerStateChange() event:" + event.data);
			break;
	}
}

function getMultipleChoiceEventPlayer(player){
		//get player pos
		var playerPos = 0;
		for (var i = 0; i < _multipleChoiceVideoPlayers.length; i++) {
			var p = _multipleChoiceVideoPlayers[i];
			if(p == player){
				playerPos = i;
			}
		}
	
		//get quiz object
		$(".multipleChoice").removeClass("active");
		var $q = $(".multipleChoice").first();
		$(".multipleChoice").each(function(){
			if($(this).attr("data-quiz-pos") == playerPos){
				$q = $(this);
			}
		});

		return $q;
}

function handleMultipleChoiceYoutubeReadyEvent(){
	$(".multipleChoice__video-player").each(function(){
		var playerId = $(this).attr("id");
		var youtubeVideoId = $("#" + playerId).attr("data-video-id");
		var videoPlayer = new YT.Player(playerId, {
			height: '360',
			width: '640',
			videoId: youtubeVideoId,
			playerVars: {
				"autoplay": 0,
				"controls": 1,
				"modestbranding": 1,
				"rel": 1
			},
			events: {
				'onReady': onMultipleChoicePlayerReady,
				'onStateChange': onMultipleChoicePlayerStateChange,
				'onError': onMultipleChoicePlayerError
			}
		});
		_multipleChoiceVideoPlayers.push(videoPlayer);
	});
}